import { Tabs, Divider } from 'antd';
import { SnippetsOutlined, BorderOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import OrdersAdminCS from './OrdersAdminCS';
import OrdersAdminCsContracts from './OrdersAdminCsContracts';
import OrdersAdminLiveContracts from './OrdersAdminLiveContracts';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { useContext, useEffect } from 'react';
import { CommonContext } from '../../Context';
const { TabPane } = Tabs;

const OrderAdmineCSTab = () => {
  //Variable declaration
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;

	//Functions
  useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);

	return (
		<div>
      <div className='uppercase font-bold text-xl'>Order Admin CS</div>
			<Divider className='my-3'/>
			<Tabs defaultActiveKey="2" >
      <TabPane
        tab={ <span className='uppercase'><BorderOutlined className='text-xl' />{constants.AdminOrderCSTab1}</span> }
        key={2}>
          <OrdersAdminCS/>
      </TabPane>
			<TabPane
        tab={ <span className='uppercase'><SnippetsOutlined className='text-xl' />{constants.AdminOrderCSTab2}</span> }
        key={1}
      >
        <OrdersAdminCsContracts/>
      </TabPane>
      <TabPane
        tab={<span className='uppercase'><SnippetsOutlined className='text-xl' />{constants.AdminOrderCSTab3}</span>}
        key={3}
      >
        <OrdersAdminLiveContracts />
      </TabPane>
			</Tabs>
		</div>
	);
};

export default OrderAdmineCSTab;